import React from "react";
import { Button, Table } from "react-bootstrap";
import { Edit, Eye, Trash } from "react-feather";
import { formatDate } from "../config/function";

const VendorAdvanceList = ({ advanceData, handleEdit, handleDelete, handleView, vendors }) => {
  const getVendorName = (vendor_id) => {
    const vendor = vendors.find((d) => d.id === vendor_id)
    return vendor ? vendor.name : vendor_id;
  }

  return (
    <Table>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Date</th>
          <th>Vendor</th>
          <th>Amount</th>
          {/* <th>Total Deduction</th> */}
          <th>Balance Amount</th>
          <th>Remarks</th>
          <th>Type</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {advanceData.length > 0 ? (
          advanceData.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td>{formatDate(item.date)}</td>
              <td style={{ textTransform: 'capitalize' }}>{getVendorName(item.vendor_id)}</td>
              <td>{item.amount.toFixed(2)}</td>
              {/* <td>{item.total_deduction}</td> */}
              <td>{item.balance_amount.toFixed(2)}</td>
              <td>{item.remarks}</td>
              <td>{item.type}</td>
              <td>{item.status}</td>
              <td>
                <div className="d-flex justify-content-center gap-2">
                  <Button variant="info" size="sm" onClick={() => handleView(item.id,item.type)}>
                    <Eye size={14} />
                  </Button>
                  <Button variant="warning" size="sm" onClick={() => handleEdit(item)}>
                    <Edit size={14} />
                  </Button>
                  <Button variant="danger" size="sm" onClick={() => handleDelete(index)}>
                    <Trash size={14} />
                  </Button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={7}>No records found</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default VendorAdvanceList;
